import SEO from '../../../components/base/SEO';
import Header from './components/Header';
import Hero from './components/Hero';
import WhyStudents from './components/WhyStudents';
import RankingList from './components/RankingList';
import AuditPoints from './components/AuditPoints';
import Footer from './components/Footer';
import Breadcrumb from '../../../components/feature/Breadcrumb';

export default function StudentCardsArticlePage() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Article',
        headline: '学生向けクレジットカードおすすめランキング｜審査に通りやすい',
        description: '学生でも作れるクレジットカードを徹底比較。三井住友カード（NL）、大手ECモール系カード、学生専用ライフカードなど、審査に通りやすく特典が充実したカードの選び方を詳しく解説します。',
        author: {
          '@type': 'Organization',
          name: 'クレジットカード比較'
        },
        datePublished: '2026-01-01',
        dateModified: new Date().toISOString().split('T')[0],
        image: 'https://public.readdy.ai/ai/img_res/a734b53b680fed879a1d20b1ab039569.jpg'
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'ホーム',
            item: 'https://yourdomain.com/'
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '記事一覧',
            item: 'https://yourdomain.com/#articles'
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: '学生向けクレジットカード',
            item: 'https://yourdomain.com/articles/student-cards'
          }
        ]
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="学生向けクレジットカードおすすめランキング｜審査に通りやすい"
        description="学生でも作れるクレジットカードを徹底比較。三井住友カード（NL）、大手ECモール系カード、学生専用ライフカードなど、審査に通りやすく特典が充実したカードの選び方を詳しく解説します。"
        keywords="クレジットカード,学生,学生向け,審査,大学生,専門学生,初めて,おすすめ"
        canonicalUrl="https://yourdomain.com/articles/student-cards"
        ogImage="https://readdy.ai/api/search-image?query=modern%20credit%20cards%20designed%20for%20students%20with%20educational%20elements%20youthful%20design%20on%20clean%20white%20background%20professional%20product%20photography%20high%20quality%20detailed%20sharp%20focus&width=1200&height=630&seq=student-cards-og&orientation=landscape"
        structuredData={structuredData}
      />
      <Header />
      <Breadcrumb items={[
        { label: 'ホーム', path: '/' },
        { label: '記事一覧', path: '/#articles' },
        { label: '学生向けクレジットカード' }
      ]} />
      <Hero />
      <WhyStudents />
      <RankingList />
      <AuditPoints />
      <Footer />
    </div>
  );
}
